import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'admin-stripe-lookup',
  templateUrl: './stripelookup.component.html',
  styleUrls: ['./stripelookup.component.scss']
})
export class AdminStripeLookupComponent implements OnInit {
  public eventForm: FormGroup;
  public paymentIntentForm: FormGroup;
  public customerForm: FormGroup;
  public paymentMethodForm: FormGroup;
  public result: any = null;
  public rawJson: string = null;
  public error: string = null;
  public loading: boolean = false;

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.eventForm = fb.group({
      eventId: new FormControl('evt_')
    });
    this.paymentIntentForm = fb.group({
      paymentIntentId: new FormControl('pi_')
    });
    this.customerForm = fb.group({
      customerId: new FormControl('cus_')
    });
    this.paymentMethodForm = fb.group({
      paymentMethodId: new FormControl('pm_')
    });
  }

  ngOnInit() {
  }

  public lookupEvent(evt) {
    evt.preventDefault();
    this.loading = true;
    this.result = null;
    this.rawJson = null;
    this.error = null;

    const eventId = this.eventForm.value.eventId.trim();

    if (!eventId) {
      this.error = 'Please enter an event ID';
      this.loading = false;
      return;
    }

    this.http.get(`/payment/stripe/lookup/${encodeURIComponent(eventId)}`).subscribe(
      (resp: any) => {
        console.log(resp);
        this.processResponse(resp);
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.error = err.error?.error || err.message || 'An error occurred';
        this.loading = false;
      }
    );
  }

  public lookupPaymentIntent(evt) {
    evt.preventDefault();
    this.loading = true;
    this.result = null;
    this.rawJson = null;
    this.error = null;

    const paymentIntentId = this.paymentIntentForm.value.paymentIntentId.trim();

    if (!paymentIntentId) {
      this.error = 'Please enter a payment intent ID';
      this.loading = false;
      return;
    }

    this.http.get(`/payment/stripe/lookup/paymentintent/${encodeURIComponent(paymentIntentId)}`).subscribe(
      (resp: any) => {
        console.log(resp);
        this.processResponse(resp);
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.error = err.error?.error || err.message || 'An error occurred';
        this.loading = false;
      }
    );
  }

  public lookupCustomer(evt) {
    evt.preventDefault();
    this.loading = true;
    this.result = null;
    this.rawJson = null;
    this.error = null;

    const customerId = this.customerForm.value.customerId.trim();

    if (!customerId) {
      this.error = 'Please enter a customer ID';
      this.loading = false;
      return;
    }

    this.http.get(`/payment/stripe/lookup/customer/${encodeURIComponent(customerId)}`).subscribe(
      (resp: any) => {
        console.log(resp);
        this.processResponse(resp);
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.error = err.error?.error || err.message || 'An error occurred';
        this.loading = false;
      }
    );
  }

  public lookupPaymentMethod(evt) {
    evt.preventDefault();
    this.loading = true;
    this.result = null;
    this.rawJson = null;
    this.error = null;

    const paymentMethodId = this.paymentMethodForm.value.paymentMethodId.trim();

    if (!paymentMethodId) {
      this.error = 'Please enter a payment method ID';
      this.loading = false;
      return;
    }

    this.http.get(`/payment/stripe/lookup/paymentmethod/${encodeURIComponent(paymentMethodId)}`).subscribe(
      (resp: any) => {
        console.log(resp);
        this.processResponse(resp);
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.error = err.error?.error || err.message || 'An error occurred';
        this.loading = false;
      }
    );
  }

  private processResponse(resp: any) {
    // Extract rawJson and format it
    if (resp.rawJson) {
      this.rawJson = resp.rawJson;
      
      // Create a copy of the response without rawJson for the structured display
      const resultWithoutRaw = { ...resp };
      delete resultWithoutRaw.rawJson;
      this.result = resultWithoutRaw;
    } else {
      this.result = resp;
      this.rawJson = null;
    }
  }

  public formatJson(obj: any): string {
    return JSON.stringify(obj, null, 2);
  }

  public formatRawJson(jsonString: string): string {
    try {
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return jsonString;
    }
  }
}
